<template>
    <v-main>
        <div v-if="initialpageloading && !varietygroup.length">
            <v-container>
                <v-row  >
                    <v-col cols="12" class="text-center">
                        <v-progress-circular
                                :size="100"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
        <v-container  v-if="varietygroup">
            <head>
                <title>{{varietygroup.name}} - Foraje</title>
                <meta name="description" :content="varietygroup.short_description">
            </head>
            <v-row  >
                <v-col class="pa-4" cols="12" sm="6" >
                    <v-card flat class="transparent" >
                        <v-carousel :cycle="false" v-if="varietygroupimages && varietygroupimages.length">
                            <v-carousel-item v-for="(item,i) in varietygroupimages" :key="i" :src="item.image.full_size" :lazy-src="item.image.thumbnail">

                            </v-carousel-item>
                        </v-carousel>
                        <v-img v-else src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                               class="white--text"></v-img>
                    </v-card>
                </v-col>
                <v-col class="pa-2" cols="12" sm="6" >
                    <v-card>
                        <v-card-title>
                        <v-col class="ma-2 mt-4" cols="9" > <!--I'd prefer to use v-card-title, but can't get it to look the way I'd like.-->
                            <h2>{{varietygroup.name}} <v-btn v-if="varietygroup.wikipedia_url !== null" v-bind:href="varietygroup.wikipedia_url" flat icon outlined large color="light-green darken-4">
                                <v-icon>mdi-wikipedia</v-icon>
                            </v-btn></h2>
                            <router-link  v-if="varietygroup.species" v-bind:to="'/guide/species/' + varietygroup.species.slug"><h4><em>{{varietygroup.species.name}}</em></h4></router-link>
                        </v-col>
                        </v-card-title>
                        <v-divider inset></v-divider>
                        <v-card-title primary-title>
                            <v-col class="ma-2 mt-4" cols="9" >
                                <span class="headline">Quick Look</span>
                            </v-col>
                        </v-card-title>
                        <v-card-text>
                            <ul>
                              <li>AKA:
                                <span v-for="name in varietygroup.common_names" :key="name.id">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                    <span v-on="on">{{name.name}}, </span>
                                    </template>
                                    <span>{{name.language}}</span>
                                  </v-tooltip>
                                </span>
                              </li>
                                <li v-if="varietygroup.short_description">{{varietygroup.short_description}}</li>
                                <li v-else-if="varietygroup.description">{{varietygroup.description.substring(0,255)}}...</li>
                                <li v-else>Sorry, we don't have a basic description for this group of varieties yet.</li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
            <v-divider></v-divider>
            <v-divider></v-divider>
        <v-tabs light fixed-tabs icons-and-text centered slider-color="yellow">
            <v-tab key="general_info">
                General Info
                <v-icon>mdi-information-outline</v-icon>
            </v-tab>
            <v-tab key="varieties" @click.native="FirstClickFetchVarieties">
                Known Varieties/Cultivars
                <v-icon>mdi-file-tree-outline</v-icon>
            </v-tab>
            <v-tab-item key="general_info">
                <v-container >
                    <v-row  >
                        <v-col cols="12">
                            <v-card>
                                <v-card-title primary-title>
                                    <h2>Description</h2>
                                </v-card-title>
                                <v-card-text>
                                    {{varietygroup.description}}
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-tab-item>

            <v-tab-item key="varieties">
                <v-container >
                    <v-row   v-if="issomethingloading && !varieties.length">
                        <v-col cols="12" class="text-center">
                            <v-progress-circular
                                    :size="100"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>


                    <v-row  >

                        <div id="KnownVarietiesTop" v-if="varieties && varieties.length"><h2>Known Varieties</h2></div>
                        <v-col v-else-if="!issomethingloading" cols="12" class="text-center">
                            <v-btn @click.native="FetchVarieties"
                                   class="primary"
                            >
                                Fetch known varieties of this species
                                <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                            </v-btn>
                        </v-col>
                        <v-row   v-if="varieties && varieties.length">
                          <v-col cols="12" sm="6" md="4" v-for="variety of varieties" :key="variety.id">

                                <v-card raised hover :to="'/guide/variety/' + variety.slug">
                                    <v-row>
                                      <v-col class="pa-sm-3 ml-sm-3 pa-10" cols="12" sm="5" v-if="variety.variety_image && variety.variety_image.image" >
                                            <!--Displays image of the Variety, a filled box for mobile (might wanna switch to a small box and hide the text
                                            or something else instead.) and a rounded image for everyone else. Also a placeholdder if there is no image-->
                                            <v-img
                                                    :src="variety.variety_image.image.thumbnail"
                                                    class="FetchedThumbail hidden-xs-only"
                                                    aspect-ratio="1"
                                            ></v-img>
                                            <v-img
                                                    :src="variety.variety_image.image.full_size"
                                                    class="hidden-sm-and-up FetchedThumbail"
                                                    aspect-ratio="1"
                                            ></v-img>
                                        </v-col>
                                        <v-col cols="12" sm="5" v-else>
                                            <v-img
                                                    src="https://nyc3.digitaloceanspaces.com/foraje-static-1/media/static/images/misc/unknownchile.svg"
                                                    class="white--text"
                                            ></v-img>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-card-title primary-title>
                                                    <div class="headline" style="word-break: normal"><router-link v-bind:to="'/guide/varieties/' + variety.slug">{{variety.name}}</router-link></div>
                                            </v-card-title>
                                          <v-card-text><p>{{variety.short_description}}</p></v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-card>

                            </v-col>
                            <!--Fetches more varieties, or lets user go back to the previous ones.
                            Use this              @click="$vuetify.goTo('#KnownVarietiesTop', { offset: 0 })"
                            if you want to force scrolling back to the top of the section. Not sure if I want that yet.
                            -->

                            <v-col cols="12" class="text-center">
                                <v-btn
                                        v-if="this.varietypageCount > 1"
                                        @click="VarietyLoadPreviousBatch"
                                        :loading="issomethingloading"
                                        class="secondary"
                                >
                                    Previous Varieties
                                    <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                                </v-btn>
                                <v-btn
                                        v-if="this.varietyfullresponse.next !== null"
                                        @click="VarietyLoadNextBatch"
                                        :loading="issomethingloading"
                                        class="primary"
                                >

                                    More Varieties!
                                    <span slot="loader" class="custom-loader">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </span>
                                </v-btn>
                            </v-col>
                        </v-row>


                    </v-row>
                </v-container>
            </v-tab-item>

        </v-tabs>
        </div>

    </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VarietyGroup',
  data: () => ({

    varietygroup: [],
    varietygroupimages: [],
    errors: [],
    dialog: false,
    varieties: [],
    varietypageCount: 1,
    issomethingloading: false,
    initialpageloading: false,
    varietyfullresponse: [],


  }),

  methods: {
    FetchVarieties() {
      const varietyGroupId = this.varietygroup.id;
      this.issomethingloading = true;
      axios.get(`filtered/variety/by/variety_group/${varietyGroupId}/?page=${this.varietypageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.varieties = response.data.results;
          this.varietyfullresponse = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    VarietyLoadNextBatch() {
      if (this.varietyfullresponse.next != null) {
        this.varietypageCount += 1;
        this.FetchVarieties();
      }
    },

    VarietyLoadPreviousBatch() {
      this.varietypageCount -= 1;
      this.FetchVarieties();
    },
    FirstClickFetchVarieties() {
      if (!this.varieties.length) {
        this.FetchVarieties();
      }
    },
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.token;
    },
  },

  // Fetches species info when the component is created.
  created() {
    this.initialpageloading = true;
    const varietygroupId = this.$route.params.slug;
    axios.get(`varietygroups/${varietygroupId}/`)
      .then((response) => {
        // JSON responses are automatically parsed.
        this.varietygroup = response.data;
        return axios.get(`/image/by/variety_group/${this.varietygroup.id}/`);
      })
      .then((response) => {
        // JSON responses are automatically parsed.
        this.varietygroupimages = response.data;
        this.initialpageloading = false;
      })
      .catch((e) => {
        this.errors.push(e);
      });

    // async / await version (created() becomes async created())
    //
    // try {
    //   const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`)
    //   this.posts = response.data
    // } catch (e) {
    //   this.errors.push(e)
    // }
  },
};
</script>

<style scoped>
    img {

        display: flex;
        width: 100%;
        height: auto;
        max-width: 800px;
        object-fit: contain;
    }
    .BasicInfo{
        display:inline-flex;
        vertical-align: top;
    }
    .Photo{
        display:inline-flex;
        vertical-align: top;
    }
    .QuickLook{
        display:flex;
        max-width: 400px;
    }
    .Vendors{
        display: flex;
        vertical-align: top;
        max-width: 500px;

    }
    .Description{
        display: flex;
        vertical-align:top;
    }

    .FetchedThumbail{
        border-radius: 50%;
    }
    >>>.v-carousel__next > .v-btn{
        background: rgba(0,0,0,.5)
    }
    >>>.v-carousel__prev > .v-btn{
        background: rgba(0,0,0,.5)
    }
</style>
